import React from "react";
import { Box, Container, Typography } from "@mui/material";

const PrivacyPage: React.FC = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Typography variant="h3" sx={{ fontWeight: "bold", mb: 3 }}>
          プライバシーポリシー
        </Typography>

        <Typography sx={{ mb: 2 }}>2023.10.14</Typography>

        <Typography sx={{ mb: 2 }}>
          TriArrows合同会社は（以下「当社」といいます）、「個人情報の保護に関する法律」に基づく
          個人情報の適正な取扱いの確保について組織として取り組むために、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます。）を定めます。
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 3 }}>
          第1条（個人情報保護の方針）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          当社は、ご本人様からお預かりした個人情報について、個人情報保護に関する法律を遵守し、お預かりした個人情報を適切に取扱いいたします。
          本ポリシーにおいて別段の定めがない限り、本ポリシーにおける用語の定義は、個人情報保護法の定めに従います。
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
          第2条（個人情報を収集・利用する目的）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          当社が個人情報を収集・利用する目的は、以下のとおりです。
        </Typography>

        <Typography sx={{ fontWeight: "bold", mt: 1 }}>
          取引先に関する個人情報
        </Typography>
        <Typography sx={{ mb: 2 }}>
          ・当社が提供するサービスに関し、商談、契約手続、取引先管理、受発注業務、請求支払業務、その他これらに付随する業務の遂行のため
          <br />
          ・お客様等のサポート、アフターサービスの充実を図るため
          <br />
          ・アンケート調査や利用状況等を分析し、当社サービス・商品の改善、当社の新サービス・新商品の開発等に役立てるため
          <br />
          ・当社サービスに関するお知らせのため
          <br />
          ・当社の開催(共催)するイベント、セミナー、新サービス等のご案内のため
        </Typography>

        <Typography sx={{ fontWeight: "bold", mt: 1 }}>
          資料請求その他当社サービス等に関するお問い合わせを頂いた方に関する個人情報
        </Typography>
        <Typography sx={{ mb: 2 }}>
          ・当社サービスに関するお知らせのため
          <br />
          ・アンケート調査や利用状況等を分析し、当社サービス・商品の改善、当社の新サービス・新商品の開発等に役立てるため
          <br />
          ・当社の開催(共催)するイベント、セミナー、新サービス等のご案内のため
        </Typography>

        <Typography sx={{ fontWeight: "bold", mt: 1 }}>
          役職員および採用応募者に関する個人情報
        </Typography>
        <Typography sx={{ mb: 2 }}>
          ・当社の採用の検討、面接のご連絡、採用結果の通知および採用関係書類の送付のため
          <br />
          ・採用、募集活動に必要な利用、採用応募者へのご連絡、当社事業や採用に関する情報提供のため
          <br />
          ・紙、メール、映像、SNS等による各種業務連絡および広報のため
          <br />
          ・報酬（賃金、賞与、諸手当等）の支払い、経費精算のため
          <br />
          ・人事、労務管理の履行のため
          <br />
          ・福利厚生の提供のため
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
          第3条（個人情報の取得）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          当社は、個人情報を取得する際には、利用目的を公表または通知し（本指針による公表を含む。）、また、直接ご本人様から契約書その他の書面（電磁的記録を含む）に記載された個人情報を取得する場合にはあらかじめ利用目的を明示し、適法かつ公正な手段によって取得いたします。
          また、当社は、利用目的の達成に必要な範囲内で、適正に個人情報を利用し、違法・不当な行為を助長・誘発するおそれがある方法によって個人情報を利用することは致しません。
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
          第4条（利用目的の変更）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          当社は、利用目的が変更前と関連性を有すると合理的に認められる場合に限り、個人情報の利用目的を変更するものとします。利用目的の変更を行った場合には、変更後の目的について、当社所定の方法により、ご本人に通知し、または当社ウェブサイト上に公表するものとします。
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
          第5条（個人情報の第三者提供の制限）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          当社は、以下の場合を除き、あらかじめご本人様の同意を得ることなく、ご本人様より取得した個人データを当社以外の第三者に提供することはありません。
        </Typography>
        <Typography sx={{ mb: 2 }}>
          1．法令に基づく場合
          <br />
          2．人の生命、身体または財産の保護のために個人データの第三者提供が必要である場合であって、本人の同意を得ることが困難であるとき。
          <br />
          3．公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき。
          <br />
          4．国の機関若しくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき。
          <br />
          5．利用目的の達成に必要な範囲内で業務の全部又は一部を委託する場合
          <br />
          6．合併、事業譲渡等による事業承継に伴い、個人情報を引き継ぐ場合
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
          第6条（安全管理措置に関する事項）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          当社は、個人データについて、漏えい、滅失又はき損の防止等、その管理のために必要かつ適切な安全管理措置を講じます。
        </Typography>

        <Typography sx={{ fontWeight: "bold", mt: 1 }}>
          （個人情報保護指針の策定）
        </Typography>
        <Typography sx={{ mb: 1 }}>
          ・個人データの適正な取扱いの確保のため、「関係法令・ガイドライン等の遵守」、「質問及び苦情処理の窓口」等について本ポリシーを策定しています。
        </Typography>

        <Typography sx={{ fontWeight: "bold", mt: 1 }}>
          （個人データの取扱いに係る規律の整備）
        </Typography>
        <Typography sx={{ mb: 1 }}>
          ・取得、利用、保存、提供、削除・廃棄等の段階ごとに、取扱方法、責任者・担当者及びその任務等について個人情報取扱規程を策定しています。
        </Typography>

        <Typography sx={{ fontWeight: "bold", mt: 1 }}>
          （組織的安全管理措置）
        </Typography>
        <Typography sx={{ mb: 1 }}>
          ・個人データの取扱いに関する事務取扱責任者を設置するとともに、個人データを取り扱う従業者及び当該従業者が取り扱う個人データの範囲を明確化し、個人情報保護法や個人情報取扱規程に違反している事実又は兆候を把握した場合の事務取扱責任者への報告連絡体制を整備しています。
          <br />
          ・個人データの取扱状況について、定期的に自己点検を実施するとともに、他部署や外部の者による監査を実施しています。
        </Typography>

        <Typography sx={{ fontWeight: "bold", mt: 1 }}>
          （人的安全管理措置）
        </Typography>
        <Typography sx={{ mb: 1 }}>
          ・個人データの取扱いに関する留意事項について、従業者に定期的な研修を実施しています。
          <br />
          ・個人データについての秘密保持に関する事項を就業規則に記載しています。
        </Typography>

        <Typography sx={{ fontWeight: "bold", mt: 1 }}>
          （物理的安全管理措置）
        </Typography>
        <Typography sx={{ mb: 1 }}>
          ・個人データを取り扱う区域において、従業者の入退室管理及び持ち込む機器等の制限を行うとともに、権限を有しない者による個人データの閲覧を防止する措置を実施しています。
          <br />
          ・個人データを取り扱う機器、電子媒体及び書類等の盗難又は紛失等を防止するための措置を講じるとともに、事業所内の移動を含め、当該機器、電子媒体等を持ち運ぶ場合、容易に個人データが判明しないよう措置を実施しています。
        </Typography>

        <Typography sx={{ fontWeight: "bold", mt: 1 }}>
          （技術的安全管理措置）
        </Typography>
        <Typography sx={{ mb: 1 }}>
          ・アクセス制御を実施して、担当者及び取り扱う個人情報データベース等の範囲を限定しています。
          <br />
          ・個人データを取り扱う情報システムを外部からの不正アクセス又は不正ソフトウェアから保護する仕組みを導入しています。
        </Typography>

        <Typography sx={{ fontWeight: "bold", mt: 1 }}>
          （個人情報の取扱の委託について）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          ・業務委託先との間で利用者等の個人データの取り扱いに関する契約を締結することをはじめ、適切に業務委託先の管理・監督を行います。
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
          第7条（事故時の通知）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          当社は、個人データの漏えい、滅失、毀損その他の個人データの安全の確保に係る事態であって個人の権利利益を害するおそれが大きいものとして個人情報保護委員会規則で定めるものが生じたときは、個人情報保護委員会規則で定めるところにより、当該事態が生じた旨を個人情報保護委員会に報告するとともに、お客様に通知致します。ただし、お客様への通知が困難な場合な場合には、必要なこれに代わるべき措置をとる場合があります。
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
          第8条（匿名加工情報・仮名加工情報・個人関連情報）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          当社は匿名加工情報及び仮名加工情報を作成するときは、個人情報保護法その他関連法令に準拠して適切に取扱います。
          また、当社が個人関連情報を第三者に提供する場合であって、当該第三者が個人データとして取得することが想定されるときは、法令の定めに従い、ご本人様の同意が得られていることを確認したうえで提供いたします。
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
          第9条（個人情報の開示）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          当社の保有個人データに関して、ご自身の個人情報の開示をご希望される場合には、ご請求いただいた方が、ご本人様であることを確認したうえで、合理的な期間及び範囲で回答します。
          但し、個人情報保護法その他の関係法令により、ご請求にお答えできない場合は、この限りではありません。
          なお、個人情報の開示につきましては、1回のご請求ごとに所定の手数料を申し受けます。あらかじめ御了承ください。
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
          第10条（訂正・削除等）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          当社の保有個人データに関して、お客様ご自身の個人情報について訂正、追加または削除をご希望される場合には、ご請求いただいた方がご本人様であることを確認したうえで、事実と異なる内容がある場合には、合理的な期間及び範囲で個人情報の訂正、追加または削除をします。
          但し、個人情報保護法その他の関係法令により、ご請求にお答えできない場合はこの限りではありません。
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
          第11条（個人情報の利用停止等）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          当社の保有個人データに関して、お客様ご自身の個人情報の利用停止または消去をご希望される場合には、ご請求いただいた方がご本人様であることを確認したうえで、合理的な期間及び範囲で利用停止または消去します。
          これらの個人情報の一部または全部を利用停止または消去した場合、ご要望に沿ったサービスの提供ができなくなることがありますので、ご理解とご協力を賜わりますようお願い申し上げます。
          (なお、関係法令に基づき保有する情報については、利用停止または消去のご請求に応じられない場合があります)。
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
          第12条（開示等の受付方法・窓口）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          当社の保有個人データに関する上記9条・10条・11条のご要望があった際には、所定の手続で、ご本人様(または代理人)であることを確認したうえで、遅滞なく対応いたします。
          本プライバシーポリシーに関するお問い合わせや、上記9条・10条・11条のご要望がおありになる場合には、下記第13条（お問い合わせ窓口）にご連絡ください。
          なお、この受付方法によらない開示等のご請求には応じられない場合がありますので、ご了承ください。
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
          第13条（お問い合わせ窓口）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          社名：TriArrows合同会社
          <br />
          代表取締役：高田治吉
          <br />
          個人情報保護管理責任者：コーポレート本部法務担当
          <br />
          問い合わせ先：info@triarrows-group.com
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
          第14条（プライバシーポリシーの変更）
        </Typography>
        <Typography sx={{ mb: 2 }}>
          当社は、必要に応じて、本ポリシーを変更します。なお、当社は、本ポリシーを変更する場合には、変更後の本ポリシーの施行時期及び内容を当社のウェブサイト上での表示その他の適切な方法により周知し、又はユーザーに通知します。
        </Typography>

        <Typography sx={{ mt: 4, color: "text.secondary" }}>
          制定日: 2024年5月4日
        </Typography>
      </Container>
    </Box>
  );
};

export default PrivacyPage;
